import { PlayerNightReminder } from "./NightReminder";
import { PlayerActions } from "./PlayerActions";
import { PlayerMenuItem } from "./PlayerMenuItem";
import { PlayerMessageFlow } from "./PlayerMessage";
import { PlayerName } from "./PlayerName";
import { PlayerNoteInput } from "./PlayerNoteInput";
import { PlayerRoleIcon } from "./PlayerRole";

export const PlayerList = {
  RoleIcon: PlayerRoleIcon,
  Name: PlayerName,
  NightReminder: PlayerNightReminder,
  Actions: PlayerActions,
  MenuItem: PlayerMenuItem,
  NoteInputModal: PlayerNoteInput,
  PlayerMessage: PlayerMessageFlow,
};
